<unity-page-container
  [contentHeader]="$contentHeader()"
  [contentHeaderSecondary]="$contentHeaderSecondary()"
  [isLoading]="$resourceLoading()">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  <ng-container notifications>
    @if (this.$isDraft()) {
      <unity-banner-alert-shared notifications icon="infoSolidIcon">
        This Agreement is in a 'Draft' state, visible only to AHFC users.
        <span *unityAuthorize="'Agreement:Transition'"> Use the actions buttons to change its state. </span>
      </unity-banner-alert-shared>
    } @else if (this.$isDisabled()) {
      <unity-banner-alert-shared notifications icon="infoSolidIcon">
        This Agreement is in a 'Disabled' state, visible only to AHFC users.
        <span *unityAuthorize="'Agreement:Transition'"> Use the actions buttons to change its state. </span>
      </unity-banner-alert-shared>
    }
  </ng-container>

  <ng-container actions>
    <unity-workflow-selector-shared
      [transitions]="$availableTransitions()"
      [disabled]="$workflowActionsDisabled()"
      (workflowEvent)="onWorkflow($event)" />
    <unity-action-delete-shared
      *unityAuthorize="deleteEntitlement"
      [disabled]="$workflowActionsDisabled()"
      [buttonText]="`Delete ${resourceName}`"
      [confirmationTitle]="`Confirm Delete ${resourceName}?`"
      [confirmationMessage]="`Are you sure you want to delete this ${resourceName}?`"
      (deleteEvent)="onDelete()" />
  </ng-container>

  @let agreementView = $resource();
  @let formGroup = $formGroup();
  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="$isEntitledToEdit()"
    [submitLoading]="$updateLoading()"
    (saveEvent)="onSave()"
    (detailEditEvent)="toggleWorkflowActions($event)">
    <unity-form-layout>
      @if (agreementView) {
        <unity-textbox-readonly-control displayName="Business Partner" [value]="agreementView.agency.name" />
        <unity-textbox-readonly-control displayName="Program" [value]="agreementView.program.name" />
      }
      <unity-textbox-control displayName="Name" description="Provide the agreement name." [control]="formGroup.controls.name" />
      @if (formGroup.controls.description) {
        <unity-textarea-control
          displayName="Description"
          description="Provide the agreement description."
          [control]="formGroup.controls.description" />
      }
      <unity-textbox-currency-control
        displayName="Award Amount"
        description="Enter the award amount, in dollars."
        [control]="formGroup.controls.award_amount" />
      @if ($hasClientExpenses()) {
        <unity-textbox-currency-control
          displayName="Total Client Program Budget"
          description="Enter the portion of the award that should be distributed to clients."
          [control]="formGroup.controls.client_share_of_award_amount" />
        <unity-textbox-currency-control
          displayName="Maximum Amount to Predict Slots"
          description="Enter the standard allocation amount, in dollars."
          [control]="formGroup.controls.client_standard_allocation_amount" />
      }
      <unity-multiselect-community-control
        description="Select the communities to include as part of this agreement."
        [control]="formGroup.controls.community_ids" />
      <unity-selector-date-control
        displayName="Agreement Date"
        description="Select the agreement date"
        [control]="formGroup.controls.agreement_date" />
      <unity-selector-date-range-control [startControl]="formGroup.controls.start_date" [endControl]="formGroup.controls.end_date" />
    </unity-form-layout>
  </unity-panel-manage-shared>
</unity-page-container>
